const TWEET_VIDEO_MEDIA_TYPES = new Set(['video', 'animated_gif'])

export function hasSyncedTweetData(url) {
    return !!url?.service_json?.id && !url?.service_json?.error
}

function declaredTweetVideoCount(url) {
    const media = url?.service_json?.media
    if (!Array.isArray(media)) return 0

    return media.filter(item => TWEET_VIDEO_MEDIA_TYPES.has(item?.type)).length
}

function resolvedTweetVideoCount(url) {
    if (!Array.isArray(url?.video_urls)) return 0
    return url.video_urls.filter(Boolean).length
}

export function isTweetResolutionComplete(url) {
    return getTweetResolutionPhase(url) === 'complete'
}

export function getTweetResolutionPhase(url) {
    if (!hasSyncedTweetData(url)) return 'metadata'

    return resolvedTweetVideoCount(url) >= declaredTweetVideoCount(url) ? 'complete' : 'media'
}
